import createNamedContext from 'utils/createNamedContext';
import { SendPointScenariosMap } from './PolicyForm/share';
import { Dispatch, SetStateAction } from 'react';
import { ActivityFormValues } from './ActivityForm/share';

export interface ScenarioConfigEditMeta {
  activityFormValues: ActivityFormValues;
  sendPointScenariosMap: SendPointScenariosMap;
}

export type ScenarioConfigs = Knowledge.Policy.ScenarioConfig[];

export interface ScenarioConfigContextValue {
  scenarioConfigEnable: boolean;
  scenarioConfigs: ScenarioConfigs;
  setScenarioConfigs: Dispatch<SetStateAction<ScenarioConfigs>>;
  refreshScenarioConfigs: () => Promise<any>;
  editScenarioConfigs: (meta: ScenarioConfigEditMeta) => void;
}

export const ScenarioConfigContext = createNamedContext<ScenarioConfigContextValue | null>(
  'ScenarioConfigContext',
  null,
);
